import { useQuery } from 'react-query'
import { get } from 'framework/api/http'

/** One process the code sends email for — mirrors API NotificationProcessCatalogueEntryModel (BDL20-4262). */
export interface NotificationProcessCatalogueEntry {
  /** Exact NotificationRecipient.ServiceName the sender resolves, e.g. AsnBatchFailure */
  serviceName: string
  /** Base process the group belongs to, e.g. AsnBatch; equals serviceName for a process without outcomes */
  process: string
  displayName: string
  outcome: 'Success' | 'Failure' | null
  defaultTag: string
  /** Partner codes the code sends this process for. Empty means any partner. */
  partnerCodes: string[]
}

export interface NotificationProcessCatalogueResponse {
  processes: NotificationProcessCatalogueEntry[]
}

/* Get the catalogue of processes the code sends email for (exact ServiceName, outcome, default tag, partner codes) */
export const getNotificationProcessCatalogue =
  async (): Promise<NotificationProcessCatalogueResponse> => {
    const res = await get('/NotificationRecipient/ProcessCatalogue')
    return res.data
  }

export const useGetNotificationProcessCatalogue = () => {
  return useQuery(
    ['emailAlertProcessCatalogue'],
    getNotificationProcessCatalogue,
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  )
}

export default useGetNotificationProcessCatalogue
